const TicketingServicess = () => {
    return (
      <div>
          <div className="flex flex-col justify-center items-center">
          <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
             
              <div className="flex flex-col justify-center">
                <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                    Ticketing Services
                </h1>
                <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                  TCS offers end-to-end ticket-sales services for all sorts of events, be it a Twenty-20 tournament, 
                  a musical concert or an exhibition. With our 1,000+ Express Centres, 2,500+ countrywide locations, 
                  branchless banking service mechanisms, and an ISO-Certified digital printshop, we are fully capable 
                  of designing, printing, and implementing customised solutions for ticket-sales.
                </p>
              </div>
              <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                <img src="/DomesticScrollingBanner/image12.jpg" alt="" className="rounded-md max-w-[100%]"/>
              </div>
            </div>
          
          </div>
        </div>
    
    )
};
export default TicketingServicess;